import { Wind, BookOpen, ListChecks, NotebookPen } from "lucide-react";

export const STEPS = [
  { key: "center", label: "Center", icon: Wind },
  { key: "learn", label: "Learn", icon: BookOpen },
  { key: "practice", label: "Practice", icon: ListChecks },
  { key: "reflect", label: "Reflect", icon: NotebookPen },
];

export const StepRail = ({ current }) => (
  <ol className="flex items-center gap-2 sm:gap-4" data-testid="lesson-step-rail">
    {STEPS.map(({ key, label, icon: Icon }, i) => {
      const state = i < current ? "done" : i === current ? "active" : "todo";
      return (
        <li key={key} className="flex items-center gap-2 sm:gap-4" data-testid={`step-${key}-${state}`}>
          <span className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm transition-colors ${
            state === "active" ? "bg-[#2C4A3E] text-white" : state === "done" ? "bg-[#E3EBE5] text-[#2C4A3E]" : "text-stone-400"}`}>
            <Icon className="w-4 h-4" /><span className="hidden sm:inline">{label}</span>
          </span>
          {i < STEPS.length - 1 && <span className="w-6 sm:w-10 h-px bg-[#E6DEC3]" />}
        </li>
      );
    })}
  </ol>
);
